"use strict";
var PowerUnit_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerUnit = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
/**
 * Power unit (Watt).
 */
let PowerUnit = PowerUnit_1 = class PowerUnit extends core_1.Unit {
};
exports.PowerUnit = PowerUnit;
PowerUnit.WATT = new PowerUnit_1('watt', {
    baseName: 'power',
    aliases: ['W', 'watts'],
});
PowerUnit.DECIBEL = new PowerUnit_1('decibel', {
    baseName: 'power',
    aliases: ['dB', 'decibel-watts'],
    prefixes: 'decimal',
    definitions: [
        {
            magnitude: 10 / Math.log10(10),
            unit: 'watt',
        },
    ],
});
PowerUnit.dBm = PowerUnit_1.DECIBEL.specifier(core_1.UnitPrefix.MILLI);
exports.PowerUnit = PowerUnit = PowerUnit_1 = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], PowerUnit);
//# sourceMappingURL=PowerUnit.js.map